import { Backdrop, CircularProgress, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import useStyles from "./useStyles"
import { useDispatch, useSelector } from "react-redux"

//import FilterButton from "../../../components/FilterButton/FilterButton"
import InfoIcon from "@mui/icons-material/Info"

import { SuborganizationAsoc } from "../SuborganizationsAsoc/SuborganizationAsoc"
import { useParams } from "react-router-dom"
import { getFirmsCustomer } from "../../../redux/actions/clients"
import BreadcrumbsComponent from "../../Declarations/Breadcrumbs/Breadcrumbs"

export default function ClientInfo() {
  const { cuit } = useParams()
  const classes = useStyles()
  const dispatch = useDispatch()
  const [searched, setSearched] = useState(false)
  //const [searchParams] = useSearchParams()
  //const location = useLocation()
  //const dataAlreadyLoaded = location.state?.dataLoaded === true
  const firmsCustomerData = useSelector(
    (state) => state?.clients.firmsCustomerData?.data,
  )
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const hasValidData =
      firmsCustomerData &&
      Array.isArray(firmsCustomerData) &&
      firmsCustomerData.length > 0 &&
      firmsCustomerData.some(
        (item) => item.customerSuborganizationCuit === cuit,
      )
    if (cuit && !hasValidData && !searched) {
      const performSearch = async () => {
        setIsLoading(true)
        try {
          await dispatch(getFirmsCustomer(cuit))
          setSearched(true)
        } finally {
          setIsLoading(false)
        }
      }
      performSearch()
    } else if (hasValidData) {
      setSearched(true)
    }
  }, [cuit, searched, dispatch, firmsCustomerData])
  const noData =
    searched &&
    !isLoading &&
    (!Array.isArray(firmsCustomerData) || firmsCustomerData.length === 0)
  if (isLoading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    )
  }
  return (
    <div className={classes.root}>
      <BreadcrumbsComponent />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>Clientes</Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: "2rem", color: "#00a78f", marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección visualizará los estudios asociados al número de CUIT:{" "}
          {cuit}
        </Typography>
      </div>

      {noData ? (
        <div
          style={{
            width: "100%",
            height: "calc(100vh - 16rem)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#4B4952",
            fontSize: "1.5rem",
            fontWeight: "bold",
          }}
        >
          No se encontraron estudios asociados
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            minHeight: "calc(100vh - 16rem)",
            overflow: "auto",
            paddingBottom: "10%",
          }}
        >
          <SuborganizationAsoc data={firmsCustomerData} />{" "}
        </div>
      )}
    </div>
    // </div>
  )
}
